<template>
  <div class="brand-list">

    <van-pull-refresh v-model="isLoading" @refresh="onRefresh" success-text="刷新成功">
      <van-list v-model="loading" :immediate-check="false" :finished="finished" finished-text="没有更多了" @load="onLoad" :offset="1">
        <div class="item-box">
          <van-row class="list">
            <!-- <div v-for="(item,i) in couponListUi" :key="i">111</div> -->
            <coupon v-for="(item,index) in couponListUi" :key="index" :coupinItem="item">
              <div class="click-div" @click="getCoupon(item)"></div>
            </coupon>

          </van-row>
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
import coupon from "@/components/coupon";

import { couponList, couponReceive } from "@/api/index";
import { Toast, Dialog } from "vant";

export default {
  name: "couponList",
  components: {
    coupon
  },
  data() {
    return {
      couponListUi: [],
      isLoading: true,
      loading: false,
      finished: false,
      data: {
        page: 0,
        size: 10
      }
    };
  },
  mounted() {
    this.data = {
      page: 1,
      size: 10
    };
    this.getcouponList(this.data);
  },
  methods: {
    onRefresh() {
      Toast("刷新成功");
      this.isLoading = false;
      this.couponListUi = [];
      this.data = {
        page: 0,
        size: 10
      };
      this.finished = false;
    },
    onLoad() {
      // 异步更新数据
      const nextPaging = {
        page: this.data.page + 1,
        size: 10
      };
      this.data = nextPaging;
      this.getcouponList(this.data);
    },
    getCoupon(info) {
      console.log(info);
      couponReceive(info.id).then(res => {
        if (res.data.errno == 0) {
          Toast("领取成功");
        } else if (res.data.errno == 501) {
          this.$router.push("/login");
        } else {
          Toast(res.data.errmsg);
        }
      });
    },
    getcouponList(data) {
      couponList(data).then(res => {
        if (res.data.errno == 0) {
          let newOfRes = JSON.parse(JSON.stringify(res.data.data));
          this.couponListUi = this.couponListUi.concat(newOfRes.data);
          // this.couponListUi = newOfRes.data;
          console.log(this.couponListUi);
          this.loading = false;
          // 数据全部加载完成
          if (this.couponListUi.length == newOfRes.count) {
            this.finished = true;
          }
        } else {
          Dialog.alert({
            title: "提示",
            message: res.data.errmsg
          });
        }
      });
    },
    navToDetail(id) {
      console.log(id);
      this.$router.push({
        path: "/type/detail",
        name: "商品详情",
        query: {
          id: id
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.click-div {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
}
.brand-list {
  height: 100%;
  background: #f4f4f4;
  overflow-y: scroll;
  .brand-top {
    position: relative;
    .brand-title {
      position: absolute;
      top: 19%;
      text-decoration: underline;
      width: 100%;
      left: 50%;
      margin-left: -50%;
      color: #fff;
      font-size: 1.8rem;
    }
    img {
      width: 100%;
      height: auto;
    }
  }
  .brand-name {
    height: 3rem;
    line-height: 3rem;
  }
}
.item-box {
  width: 100%;
  margin-top: 1rem;
  padding: 0 0.9rem;
  box-sizing: border-box;
  // height: 100%;

  .list {
    width: 100%;
    height: 100%;

    margin: 0 auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/index/couponList.vue